import {useEffect} from 'react'
import {shallowEqual, useSelector} from 'react-redux'
import {Navigate, Route, Routes, useNavigate} from 'react-router'
import {RootState, UserReducer} from 'setup'

import {AuthLayout as OldAuthLayout} from './AuthLayout'
import {Auth} from './components/Auth'
import {ForgotPassword as OldForgotPassword} from './components/ForgotPassword'
import {Login as OldLogin} from './components/Login'
import {ResetPassword} from './components/ResetPassword'
import {AuthLayout as NewAuthLayout} from './new/AuthLayout'
import {ForgotPassword as NewForgotPassword} from './new/components/ForgotPassword'
import {Login as NewLogin} from './new/components/Login'

const AuthPage = () => {
  const navigate = useNavigate()

  const {isLoggedIn} = useSelector<RootState>(
    (state) => state.userReducer,
    shallowEqual
  ) as UserReducer

  const newScreens =
    (useSelector<RootState>(
      (state) => state.mainReducer.generalSettings.new_login_screen,
      shallowEqual
    ) as boolean) || false

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  let AuthLayout = OldAuthLayout
  let ForgotPassword = OldForgotPassword
  let Login = OldLogin
  if (newScreens) {
    AuthLayout = NewAuthLayout
    ForgotPassword = NewForgotPassword
    Login = NewLogin
  }

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='reset-password' element={<ResetPassword />} />
        <Route index element={<Auth />} />

        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export {AuthPage}
